import { useTranslation } from "react-i18next";
import { Fragment, useState } from "react";
import submit from "submit-form";
import { S3 } from "../../../../constants";
import SvgIcon from "../../../../parts/SvgIcon";
import { getConversationLabelColor } from "../../../../utils/chat-util";
import {
  isActiveUserTheCoach,
  isTestAthlete,
} from "../../../../utils/user-helpers";

const resendInvite = (e, email) => {
  e.preventDefault();

  submit(`/coaching-portal/athletes/resend-invite`, {
    method: "POST",
    body: {
      email,
    },
  });
};

const cancelInvite = (e, email, organizationCoach) => {
  e.preventDefault();
  let body = { email };
  if (organizationCoach) {
    body = { ...body, organizationCoachId: organizationCoach };
  }
  submit(`/coaching-portal/athletes/cancel-invite`, {
    method: "POST",
    body,
  });
};

const MENU_OPTIONS = (
  athleteId,
  nutritionCondition = false,
  reportsCondition = false,
  isInactive = true,
  organizationCoach,
  organizationRoleName,
  athleteIsFromOtherOrganizationCoach,
  t
) => {
  const menu = [];
  const organizationQuery =
    athleteIsFromOtherOrganizationCoach ?? organizationCoach;

  menu.push({
    label: t("athletes.menu.profile"),
    iconSrc: "/img/new-icons/Profile-dark.svg",
    url: organizationQuery
      ? `/athlete-portal/profile/?athlete=${athleteId}&section=dashboard&organizationCoach=${organizationQuery}`
      : `/athlete-portal/profile/?athlete=${athleteId}&section=dashboard`,
  });
  if (organizationRoleName !== "Nutritionist") {
    menu.push({
      label: t("athletes.menu.programs"),
      iconSrc: "/img/new-icons/dumbbell-dark.svg",

      url: organizationQuery
        ? `/athlete-portal/programs/?athlete=${athleteId}&organizationCoach=${organizationQuery}`
        : `/athlete-portal/programs/?athlete=${athleteId}`,
    });
  }

  if (!isInactive && organizationRoleName !== "Nutritionist") {
    menu.push({
      label: t("athletes.menu.calendar"),
      iconSrc: "/img/new-icons/Calendar-Dark.svg",

      url: organizationQuery
        ? `/athlete-portal/calendar/?athlete=${athleteId}&organizationCoach=${organizationQuery}`
        : `/athlete-portal/calendar/?athlete=${athleteId}`,
    });
  }

  if (nutritionCondition) {
    menu.push({
      label: t("athletes.menu.nutrition"),
      iconSrc: "/img/new-icons/Nutrition-dark.svg",

      url: organizationQuery
        ? `/athlete-portal/nutrition/?athlete=${athleteId}&organizationCoach=${organizationQuery}`
        : `/athlete-portal/nutrition/?athlete=${athleteId}`,
    });
  }

  if (reportsCondition) {
    menu.push({
      label: t("athletes.menu.reports"),
      iconSrc: "/img/new-icons/Report-dark.svg",

      url: organizationQuery
        ? `/athlete-portal/metrics/exercise-history?athlete=${athleteId}&organizationCoach=${organizationQuery}`
        : `/athlete-portal/metrics/exercise-history?athlete=${athleteId}`,
    });
  }

  return menu;
};

const INVITED_MENU_OPTIONS = (athlete, organizationCoach, t) => {
  const menu = [
    {
      label: athlete.notRegistered
        ? t("athletes.invitedMenu.userNotRegistered")
        : t("athletes.invitedMenu.registeredUser"),
      iconSrc: athlete.notRegistered
        ? "/img/new-icons/user-registered.svg"
        : "/img/new-icons/user-registered.svg",
      url: "#",
    },
    {
      label: t("athletes.invitedMenu.coachingRequestPending"),
      iconSrc: "/img/new-icons/coaching-request.svg",
      url: "#",
    },
    {
      label: t("athletes.invitedMenu.resendInvitation"),
      iconSrc: "/img/new-icons/resend-invite.svg",
      url: "#",
      action: (e) => resendInvite(e, athlete.email),
    },
    {
      label: t("athletes.invitedMenu.cancelInvite"),
      iconSrc: "/img/new-icons/cancel-invite.svg",
      url: "#",
      action: (e) => cancelInvite(e, athlete.email, organizationCoach),
    },
    {
      label: t("athletes.invitedMenu.help"),
      iconSrc: "/img/new-icons/help.svg",
      url: "/dashboard/support/contact",
    },
  ];
  return menu;
};
const getAthleteMenu = (
  athlete,
  pending,
  organizationCoach,
  organizationRoleName,
  athleteIsFromOtherOrganizationCoach,
  t
) => {
  if (pending && !athlete.status?.inactive) {
    return INVITED_MENU_OPTIONS(athlete, organizationCoach, t);
  }
  return MENU_OPTIONS(
    athlete._id,
    Boolean(athlete.status && !athlete.status.inactive),
    Boolean(athlete.status && !athlete.status.inactive),
    athlete.status?.inactive,
    organizationCoach,
    organizationRoleName,
    athleteIsFromOtherOrganizationCoach,
    t
  );
};

export const MobileAthlete = ({
  athlete,
  pending = false,
  activeUser,
  selectedAthlete,
  handleSelectedAthlete,
  organizationCoach,
  organizationRoleName,
}) => {
  const [hoverActive, setHoverActive] = useState(false);
  const isTestUser = isTestAthlete(athlete.email, activeUser.email);

  const athleteIsFromOtherOrganizationCoach =
    activeUser.organizationId &&
    athlete.coachId &&
    !isActiveUserTheCoach(activeUser._id, athlete.coachId)
      ? athlete.coachId
      : undefined;

  const isGymMember = athlete.isGymMember;
  const isAthleteSelected = selectedAthlete === athlete._id;
  const pressLabelColor = getConversationLabelColor("PRESS");
  const { t } = useTranslation("coaching-portal");
  return (
    <article
      className="only-show-mobile"
      onMouseEnter={() => {
        if (globalThis.window !== undefined) {
          if (window.innerWidth > 960) return setHoverActive(true);
          return null;
        }
        return setHoverActive(true);
      }}
      onMouseLeave={() => {
        if (globalThis.window !== undefined) {
          if (window.innerWidth > 960) return setHoverActive(false);
          return null;
        }
        return setHoverActive(false);
      }}
    >
      {isTestUser && !(hoverActive || isAthleteSelected) && (
        <div className="test-account-label">
          <span>Test Account</span>
        </div>
      )}
      {isGymMember && !isTestUser && !(hoverActive || isAthleteSelected) && (
        <div
          className="press-label"
          style={{
            border: `1px solid ${pressLabelColor.color}`,
            color: pressLabelColor.color,
            backgroundColor: pressLabelColor.background,
          }}
        >
          PRESS
        </div>
      )}
      {hoverActive || isAthleteSelected ? (
        <ul>
          {getAthleteMenu(
            athlete,
            pending,
            organizationCoach,
            organizationRoleName,
            athleteIsFromOtherOrganizationCoach,
            t
          ).map(({ label, iconSrc, url, action = null }, idx) => {
            if (label === "Reports") {
              return (
                <Fragment key={label}>
                  <a
                    className="mobile-hidden"
                    href={url}
                    onClick={(e) => {
                      if (!action) return;
                      action(e);
                    }}
                  >
                    <SvgIcon src={iconSrc} alt={`icon-${idx}`} />
                    <p>{label}</p>
                  </a>
                  <a
                    className="only-show-mobile"
                    href={`/athlete-portal/metrics/reports-menu?athlete=${athlete._id}`}
                    onClick={(e) => {
                      if (!action) return;
                      action(e);
                    }}
                  >
                    <SvgIcon src={iconSrc} alt={`icon-${idx}`} />
                    <p>{label}</p>
                  </a>
                </Fragment>
              );
            }
            return (
              <a
                href={url}
                key={label}
                onClick={(e) => {
                  if (!action) return;
                  action(e);
                }}
              >
                <SvgIcon src={iconSrc} alt={`icon-${idx}`} />
                <p>{label}</p>
              </a>
            );
          })}
        </ul>
      ) : (
        <div
          onClick={() => {
            if (globalThis.window !== undefined && window.innerWidth <= 960) {
              return handleSelectedAthlete(athlete._id);
            }
          }}
        >
          <div data-default={athlete.avatar?.s3Path ? undefined : true}>
            {athlete.avatar?.s3Path ? (
              <img
                src={`${S3.PATH}${athlete.avatar.s3Path}`}
                alt={`${athlete.name} profile`}
                loading="lazy"
              />
            ) : (
              <SvgIcon src="/img/new-icons/user-circle.svg" />
            )}
          </div>
          <div
            className={
              pending && athlete?.email?.length > 23 ? "pending-email-div" : ""
            }
          >
            <span
              className={
                pending && athlete?.email?.length > 23
                  ? "pending-email-text"
                  : ""
              }
            >
              <b>{athlete.name || athlete.email}</b>
            </span>
            {!pending && athlete.groups?.length ? (
              <span>{athlete.groups.join(" | ")}</span>
            ) : null}
          </div>
        </div>
      )}
    </article>
  );
};

export const Athlete = ({
  athlete,
  pending = false,
  activeUser,
  selectedAthlete,
  handleSelectedAthlete,
  organizationCoach,
  organizationRoleName,
}) => {
  const { t } = useTranslation("coaching-portal");
  const hoverActive = false;
  const isTestUser = isTestAthlete(athlete.email, activeUser.email);
  const isDemoAccount = athlete.isDemo;

  const athleteIsFromOtherOrganizationCoach =
    activeUser.organizationId &&
    athlete.coachId &&
    !isActiveUserTheCoach(activeUser._id, athlete.coachId)
      ? athlete.coachId
      : undefined;

  const isGymMember = athlete.isGymMember;
  const isAthleteSelected = selectedAthlete === athlete._id;
  const pressLabelColor = getConversationLabelColor("PRESS");

  return (
    <article className="mobile-hidden athlete-card-wrapper">
      {isTestUser && !(hoverActive || isAthleteSelected) && (
        <div className="test-account-label">
          <span>Test Account</span>
        </div>
      )}
      {isGymMember && !isTestUser && !(hoverActive || isAthleteSelected) && (
        <div
          className="press-label"
          style={{
            border: `1px solid ${pressLabelColor.color}`,
            color: pressLabelColor.color,
            backgroundColor: pressLabelColor.background,
          }}
        >
          PRESS
        </div>
      )}
      {isDemoAccount && (
        <div className="test-account-label">
          <span>Demo Account</span>
        </div>
      )}
      <ul>
        {getAthleteMenu(
          athlete,
          pending,
          organizationCoach,
          organizationRoleName,
          athleteIsFromOtherOrganizationCoach,
          t
        ).map(({ label, iconSrc, url, action = null }, idx) => {
          if (label === "Reports") {
            return (
              <Fragment key={label}>
                <a
                  className="mobile-hidden"
                  href={url}
                  onClick={(e) => {
                    if (!action) return;
                    action(e);
                  }}
                >
                  <SvgIcon src={iconSrc} alt={`icon-${idx}`} />
                  <p>{label}</p>
                </a>
                <a
                  className="only-show-mobile"
                  href={`/athlete-portal/metrics/reports-menu?athlete=${athlete._id}`}
                  onClick={(e) => {
                    if (!action) return;
                    action(e);
                  }}
                >
                  <SvgIcon src={iconSrc} alt={`icon-${idx}`} />
                  <p>{label}</p>
                </a>
              </Fragment>
            );
          }
          return (
            <a
              href={url}
              key={label}
              onClick={(e) => {
                if (!action) return;
                action(e);
              }}
            >
              <SvgIcon src={iconSrc} alt={`icon-${idx}`} />
              <p>{label}</p>
            </a>
          );
        })}
      </ul>
      <div
        onClick={() => {
          if (globalThis.window !== undefined && window.innerWidth <= 960) {
            return handleSelectedAthlete(athlete._id);
          }
        }}
      >
        <div data-default={athlete.avatar?.s3Path ? undefined : true}>
          {athlete.avatar?.s3Path ? (
            <img
              src={`${S3.PATH}${athlete.avatar.s3Path}`}
              alt={`${athlete.name} profile`}
              loading="lazy"
            />
          ) : (
            <SvgIcon src="/img/new-icons/user-circle.svg" />
          )}
        </div>
        <div
          className={
            pending && athlete?.email?.length > 23 ? "pending-email-div" : ""
          }
        >
          <span
            className={
              pending && athlete?.email?.length > 23 ? "pending-email-text" : ""
            }
          >
            <b>{athlete.name || athlete.email}</b>
          </span>
          {!pending && athlete.groups?.length ? (
            <p className="p6">{athlete.groups.join(" | ")}</p>
          ) : null}
        </div>
      </div>
    </article>
  );
};
